import { IAccountProfile } from "interfaces/account/accountProfile.interface";
import {
  IMerchantState,
  ICreditsState,
  IVouchersState,
  IMessagesState,
  ICustomListSliceState,
} from "../interfaces/redux/reducers";

export const ACCOUNT_DETAILS_INITIAL_VALUE: IAccountProfile = {
  id: "",
  name: "",
  points: null,
  eListaAvailableBalance: null,
  eListaTotalBalance: null,
  maxElistaLimit: null,
  fmcg_store_id: "",
  store: {
    id: "",
    name: "",
    address: "",
    cluster: null,
    is_mobile_verified: false,
    store_category: {
      name: "",
      payment_options: [],
    },
  },
  fmcg_profile: {
    id: "",
    account: {
      id: "",
      username: "",
      displayName: "",
      email: "",
      state: "",
      type: "",
      role: "",
      isLocked: "",
      croCollectionLimit: "",
      profilePic: "",
      employeeId: "",
      store: {
        id: "",
        account_id: "",
        name: "",
        photo: "",
        address: "",
        contact_no: "",
        customer_name: "",
        city: "",
        cluster_id: "",
        loyalty_status: "",
        is_order_blocked: "",
        is_points_purchase_blocked: "",
        is_telco_blocked: "",
        point_x: "",
        point_y: "",
        province: "",
        locality: "",
        is_mobile_verified: "",
        is_self_store: "",
        online_shop_link: "",
        retailer_type: "",
        store_category_id: "",
        is_key_account: null,
        store_categories: [],
        is_paylater_blocked: "",
        loan_due: "",
        loan_due_date: "",
        loan_phase: "",
        referral_code: "",
        referral_msg: "",
        security_questions_answered: false,
      },
    },
  },
};

export const MERCHANT_INITIAL_VALUE: IMerchantState = {
  merchants: [],
  is_merchants_loading: false,
  is_merchants_empty: false,
};

export const CREDITS_INITIAL_VALUE: ICreditsState = {
  credits_service_options: [],
  loading_credit_service_options: false,
};

export const VOUCHERS_INITIAL_VALUE: IVouchersState = {
  allVouchers: [],
  vouchersLoading: true,
  crpVouchers: [],
  skuAndTocVouchers: [],
  skuVouchers: [],
  promotions: [],
};

export const MESSAGES_INITIAL_VALUE: IMessagesState = {
  is_messages_loading: true,
  messages: [],
  message: {
    id: 0,
    text: "",
    subject: "",
    created_at: "",
  },
};

export const CUSTOM_LIST_INITIAL_VALUE: ICustomListSliceState = {
  customList: [],
  isFetchingCustomList: false,
};
